import { useEffect, useState } from 'react';

const query = (q) => {
    try {
        return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(q) : null;
    } catch (e) {
        return null;
    }
};

/**
 * Whether a CSS media query matches, kept up to date. Without matchMedia
 * (old browsers, jsdom) it reports false.
 */
export default function useMediaQuery(q) {
    const [matches, setMatches] = useState(() => Boolean(query(q)?.matches));
    useEffect(() => {
        const mql = query(q);
        if (!mql) return undefined;
        const onChange = () => setMatches(mql.matches);
        onChange();
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener?.(onChange);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener?.(onChange);
        };
    }, [q]);
    return matches;
}
